<template>
    <Section width="md">
        <div class="sorting">
            <button 
                :class="{active: activeSort === 'recommended'}" 
                @click="activeSort = 'recommended'"
            >
                {{ $translate('sort_recommended', 'Rekommenderade först') }}
            </button>
            <button 
                :class="{active: activeSort === 'alphabetical'}" 
                @click="activeSort = 'alphabetical'"
            >
                {{ $translate('sort_alphabetical', 'Alfabetiskt') }}
            </button>
        </div>
        <ul>
            <CreditCard
                v-for="(card, index) in cardsToDisplay"
                v-show="!initialAmountToShow || index + 1 <= initialAmountToShow"
                :id="card.id"
                :key="card.id"
                placement="list"
                :position="index + 1"
            />
        </ul>
        <div v-if="initialAmountToShow && cardsToDisplay.length > initialAmountToShow" class="show-more-wrapper">
            <Button
                :text="$translate('show_more', 'Visa fler')"
                icon="fas fa-chevron-down"
                background="pink"
                size="sm"
                class="show-more-btn"
                @click="initialAmountToShow = null"
            />
        </div>
    </Section>
</template>

<script>
import { orderBy, partition } from 'lodash';
import CreditCard from '@/components/cards/CreditCard.vue';
import InsertCardsAtPosition from '@/mixins/insert-cards-at-position.js';
export default {
    components: { CreditCard },
    mixins: [InsertCardsAtPosition],
    props: {
        slice: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            activeSort: 'recommended',
            initialAmountToShow: this.slice.primary.initial_amount_to_show ?? null,
        };
    },
    computed: {
        activeCards() {
            return Object.values(this.$store.state.cards)
                .filter(card => {
                    const model = new this.$models.CreditCard(card);
                    return model?.isActive;
                });
        },
        cards() {
            if (this.activeSort === 'recommended') {
                const [partnerCards, otherCards] = partition(this.activeCards, 'data.redirect_enabled');
                return [
                    ...this.$getOrderedList(partnerCards),
                    ...this.$getOrderedList(otherCards)
                ];
            }
            return orderBy(this.activeCards, 'data.title', 'asc');
        },
        cardsToDisplay() {
            return this.insertCardsAtPositions(this.cards);
        }
    }
};
</script>

<style lang="scss" scoped>
    .section-inner {
        .sorting {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            row-gap: 0.5rem;
            margin-bottom: 1rem;
            @include font-size(16px);
            font-weight: bold;
            font-family: $fontHeader;
            button {
                all: unset;
                padding: 8px 16px;
                transition: all 0.2s ease-in-out;
                cursor: pointer;
                background: $white;
                @include border();
                border-radius: 5px;
                box-shadow: $btnShadow;
                white-space: nowrap;
                &:hover:not(.active) {
                    box-shadow: unset;
                }
                &.active {
                    border-color: $pink;
                    background: $pink;
                    color: $white;
                }
            }
        }
        ul {
            @include grid(1, 40px);
        }
     
        .show-more-wrapper {
            margin-top: 1rem;
            display: flex; 
            justify-content: center;
        }
    }
</style>
